import { Capacitor, registerPlugin } from '@capacitor/core'

// The Gate 1 native plugin (android Gate1Plugin.java, ios Gate1Plugin.swift),
// with a browser stand-in so the lab runs on a desktop too.
export const Gate1 = registerPlugin('Gate1', {
    web: () => import('./webGate1').then(m => new m.Gate1Web()),
})

export const platform = Capacitor.getPlatform()
export const isNative = Capacitor.isNativePlatform()
